var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "navbar-subscriptions" },
    [
      _c("TabControl", {
        ref: "tabControl",
        attrs: { tabs: _vm.tabs, "more-link": _vm.moreLink },
        scopedSlots: _vm._u([
          {
            key: "header-item",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "navbar-subscriptions-filter" },
                  [
                    _c("VDropdown", {
                      attrs: { round: "", items: _vm.filterItems },
                      model: {
                        value: _vm.selectedFilter,
                        callback: function ($$v) {
                          _vm.selectedFilter = $$v
                        },
                        expression: "selectedFilter",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }